<template>
  <div class="ace-wrapper">
    <header id="ace-header" class="ace-container-shift ace-logo-in ace-head-boxed ace-nav-right">
      <div class="ace-head-inner">
        <div class="ace-head-container ace-container">
          <div class="ace-head-row">
            <div id="ace-head-col1" class="ace-head-col text-left">
              <router-link id="ace-logo" class="ace-logo" to="/">
                <img src="/static/img/uploads/brand/logo.svg" alt="ace resume"><span>.Yangxl</span>
              </router-link>
            </div>

            <div id="ace-head-col2" class="ace-head-col text-right">
              <div class="ace-nav-container ace-container hidden-sm hidden-xs">
                <nav id="ace-main-nav">
                  <ul class="clear-list">
<!--                    <li>-->
<!--                      <router-link to="/portfolio">游览</router-link>-->
<!--                    </li>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <router-link to="/testimonials">就职</router-link>-->
<!--                    </li>-->
<!--                    &lt;!&ndash;                    <li>-->
<!--                      <router-link to="/search">搜索</router-link>-->
<!--                    </li> &ndash;&gt;-->
<!--                    <li>-->
<!--                      <router-link to="/category">博客</router-link>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <router-link to="/contact">联系方式</router-link>-->
<!--                    </li>-->
                  </ul>
                </nav>
              </div>
            </div>
<!--            <div id="ace-head-col3" class="ace-head-col text-right">-->
<!--              <button id="ace-sidebar-btn" class="btn btn-icon btn-light btn-shade">-->
<!--                <span class="ace-icon ace-icon-side-bar-icon"></span>-->
<!--              </button>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </header>
<!--    <nav id="ace-nav-sm" class="ace-nav hidden-lg hidden-md">-->
<!--      <ul class="clear-list">-->
<!--        <li>-->
<!--          <router-link data-tooltip="Home" to="/Home"><img class="avatar avatar-42"-->
<!--              src="/static/img/uploads/avatar/avatar.jpg" alt=""></router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <router-link to="/search" data-tooltip="Experience"><span class="ace-icon ace-icon-experience"></span>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <router-link to="/portfolio" data-tooltip="Portfolio"><span class="ace-icon ace-icon-portfolio"></span>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <router-link to="/testimonials" data-tooltip="References"><span class="ace-icon ace-icon-references"></span>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <router-link to="/contact" data-tooltip="Contact"><span class="ace-icon ace-icon-contact"></span>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <router-link to="/category" data-tooltip="Blog"><span class="ace-icon ace-icon-blog"></span></router-link>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </nav>-->
    <article id="ace-card" class="ace-card bg-primary">
      <div class="ace-card-inner text-center">
        <img class="avatar avatar-195" src="/static/img/uploads/avatar/avatar.jpg" width="195" height="195" alt="">
        <h1>杨晓磊</h1>
        <p class="text-muted">JAVA | 程序员</p>
<!--        <ul class="ace-social clear-list">-->
<!--          <li><a><span class="ace-icon ace-icon-wechat"></span></a></li>-->
<!--          <li><a><span class="ace-icon ace-icon-twitter"></span></a></li>-->
<!--          <li><a><span class="ace-icon ace-icon-weibo"></span></a></li>-->
<!--          <li><a><span class="ace-icon ace-icon-qq"></span></a></li>-->
<!--        </ul>-->
      </div>

<!--      <footer class="ace-card-footer">-->
<!--        <a class="btn btn-lg btn-block btn-thin btn-upper " href="#">下载简历</a>-->
<!--      </footer>-->
    </article>
    <div id="ace-content" class="ace-container-shift">
      <div class="ace-container">
        <div id="ace-nav-wrap" class="hidden-sm hidden-xs">
          <div class="ace-nav-cont">
            <div id="ace-nav-scroll">
              <nav id="ace-nav" class="ace-nav">
                <ul class="clear-list">
                  <li>
                    学
                  </li>
                  <li>
                    无
                  </li>
                  <li>
                    止
                  </li>
                  <li>
                    境
                  </li>
                  <li>
                    学
                  </li>
                  <li>
                    永
                  </li>
                  <li>
                    攀
                  </li>
                  <li>
                    高
                  </li>
                  <li>
                    峰
                  </li>
                </ul>
              </nav>
            </div>
            <div id="ace-nav-tools" class="hidden">
              <span class="ace-icon ace-icon-dots-three-horizontal"></span>

              <button id="ace-nav-arrow" class="clear-btn">
                <span class="ace-icon ace-icon-chevron-thin-down"></span>
              </button>
            </div>
          </div>
          <div class="ace-nav-btm"></div>
        </div>

        <div class="ace-paper-stock">
          <main class="ace-paper clearfix">
            <div class="ace-paper-cont clear-mrg">
              <router-view></router-view>
            </div>
          </main>
        </div>
      </div>
    </div>
<!--    <div id="ace-sidebar">-->
<!--      <button id="ace-sidebar-close" class="btn btn-icon btn-light btn-shade">-->
<!--        <span class="ace-icon ace-icon-close"></span>-->
<!--      </button>-->

<!--      <div id="ace-sidebar-inner">-->
<!--        <nav id="ace-main-nav-sm" class="visible-xs visible-sm text-center">-->
<!--          <ul class="clear-list">-->
<!--            <li><a href="portfolio.html">portfolio</a>-->
<!--            <li><a href="testimonials.html">references</a></li>-->
<!--            <li class="has-sub-menu"><a href="#">pages</a>-->
<!--              <ul class="sub-menu">-->
<!--                <li><a href="typography.html">typography</a></li>-->
<!--                <li><a href="components.html">components</a></li>-->
<!--                <li><a href="search.html">search</a></li>-->
<!--                <li><a href="404.html">404</a></li>-->
<!--              </ul>-->
<!--            </li>-->
<!--            <li class="has-sub-menu"><a href="category.html">blog</a>-->
<!--              <ul class="sub-menu">-->
<!--                <li><a href="single.html">single</a></li>-->
<!--                <li><a href="single-image.html">single image</a></li>-->
<!--                <li><a href="single-slider.html">single slider</a></li>-->
<!--                <li><a href="single-youtube.html">single youtube</a></li>-->
<!--                <li><a href="single-vimeo.html">single vimeo</a></li>-->
<!--                <li><a href="single-dailymotion.html">single dailymotion</a></li>-->
<!--                <li><a href="single-soundcloud.html">single soundcloud</a></li>-->
<!--                <li><a href="single-video.html">single video</a></li>-->
<!--                <li><a href="single-audio.html">single audio</a></li>-->
<!--              </ul>-->
<!--            </li>-->
<!--            <li><a href="contact.html">contact</a></li>-->
<!--          </ul>-->
<!--        </nav>&lt;!&ndash; #ace-main-nav-sm &ndash;&gt;-->

<!--        <article class="ace-card bg-primary">-->
<!--          <div class="ace-card-inner text-center">-->
<!--            <img class="avatar avatar-195" src="/static/img/uploads/avatar/avatar.jpg" width="195" height="195" alt="">-->
<!--            <h1>Ola Lowe</h1>-->
<!--            <p class="text-muted">Florist | Decorator</p>-->
<!--            <ul class="ace-social clear-list">-->
<!--              <li><a><span class="ace-icon ace-icon-wechat"></span></a></li>-->
<!--              <li><a><span class="ace-icon ace-icon-twitter"></span></a></li>-->
<!--              <li><a><span class="ace-icon ace-icon-weibo"></span></a></li>-->
<!--              <li><a><span class="ace-icon ace-icon-qq"></span></a></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </article>&lt;!&ndash; #ace-card &ndash;&gt;-->

<!--        <aside class="widget-area">-->
<!--          <section class="widget widget_search">-->
<!--            <form role="search" method="get" class="search-form" action="http://sc.chinaz.com/jiaoben/">-->
<!--              <label>-->
<!--                <span class="screen-reader-text">Search for:</span>-->
<!--                <input type="search" class="search-field" placeholder="Search" value="" name="s">-->
<!--              </label>-->
<!--              <button type="submit" class="search-submit">-->
<!--                <span class="screen-reader-text">Search</span>-->
<!--                <span class="ace-icon ace-icon-search"></span>-->
<!--              </button>-->
<!--            </form>-->
<!--          </section>-->

<!--          <section class="widget widget_posts_entries">-->
<!--            <h2 class="widget-title">popular posts</h2>-->
<!--            <ul>-->
<!--              <li>-->
<!--                <a class="post-image" href="">-->
<!--                  <img src="http://noemi.px-lab.com/wp-content/uploads/2016/05/tttt-70x70.png" alt="">-->
<!--                </a>-->
<!--                <div class="post-content">-->
<!--                  <h3>-->
<!--                    <a href="">contextual advertising</a>-->
<!--                  </h3>-->
<!--                </div>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Work</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li>-->
<!--                <a class="post-image" href="">-->
<!--                  <img src="http://noemi.px-lab.com/wp-content/uploads/2016/05/IMG_8945-1-70x70.jpg" alt="">-->
<!--                </a>-->
<!--                <div class="post-content">-->
<!--                  <h3>-->
<!--                    <a href="">grilling tips for the dog days of summer</a>-->
<!--                  </h3>-->
<!--                </div>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Work</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->

<!--              <li>-->
<!--                <a class="post-image" href="">-->
<!--                  <img src="http://noemi.px-lab.com/wp-content/uploads/2016/05/15-70x70.png" alt="">-->
<!--                </a>-->
<!--                <div class="post-content">-->
<!--                  <h3><a href=""></a>branding do you know who are</h3>-->
<!--                </div>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Work</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </section>-->

<!--          <section id="tag_cloud-2" class="widget widget_tag_cloud">-->
<!--            <h2 class="widget-title">Tags</h2>-->
<!--            <div class="tagcloud">-->
<!--              <a href="http://sc.chinaz.com/jiaoben/tag/audios/" class="tag-link-5 tag-link-position-1" title="1 topic"-->
<!--                style="font-size: 1em;">Audios</a>-->
<!--              <a href="" class="tag-link-7 tag-link-position-2" title="1 topic" style="font-size: 1em;">Freelance</a>-->
<!--            </div>-->
<!--          </section>-->

<!--          <section id="recent-posts-3" class="widget widget_recent_entries">-->
<!--            <h4 class="widget-title">Recent Posts</h4>-->
<!--            <ul>-->
<!--              <li>-->
<!--                <a href="">Global Travel And Vacations Luxury Travel On A Tight Budget</a>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Photography</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="">cooking for one</a>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Work</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="">An Ugly Myspace Profile Will Sure Ruin Your Reputation</a>-->
<!--                <div class="post-category-comment">-->
<!--                  <a href="" class="post-category">Photography</a>-->
<!--                  <a href="" class="post-comments">256 comments</a>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </section>-->

<!--          <section class="widget widget_categories">-->
<!--            <h4 class="widget-title">post categories</h4>-->
<!--            <ul>-->
<!--              <li class="cat-item"><a href="">Audios</a>5</li>-->
<!--              <li class="cat-item"><a href="">Daili Inspiration</a>2</li>-->
<!--              <li class="cat-item"><a href="">Freelance</a>27</li>-->
<!--              <li class="cat-item"><a href="">Links</a>5</li>-->
<!--              <li class="cat-item"><a href="">Mobile</a>2</li>-->
<!--              <li class="cat-item"><a href="">Phography</a>27</li>-->
<!--            </ul>-->
<!--          </section>-->
<!--        </aside>-->

<!--      </div>&lt;!&ndash; #ace-sidebar-inner &ndash;&gt;-->
<!--    </div>-->
    <footer id="ace-footer" class="ace-container-shift">
      <div class="ace-container">
        <div class="ace-footer-cont clear-mrg">
<!--          <p class="text-center">Copyright &copy; 2021.Yangxl</p>-->
        </div>
      </div><!-- .ace-container -->
    </footer>
    <svg id="ace-bg-shape-1" class="hidden-sm hidden-xs" height="519" width="758">
      <polygon points="0,455,693,352,173,0,92,0,0,71" style="fill:#d2d2d2;stroke:purple;stroke-width:0; opacity: 0.5" />
    </svg>
    <svg id="ace-bg-shape-2" class="hidden-sm hidden-xs" height="536" width="633">
      <polygon points="0,0,633,0,633,536" style="fill:#c0e3e7;stroke:purple;stroke-width:0" />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    created: function() {}
  }
</script>



// WEBPACK FOOTER //
// src/App.vue